import React, { PureComponent } from 'react'

import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

import Add from '@material-ui/icons/Add'
import Remove from '@material-ui/icons/Remove'
import { LocationIcon, HeatmapToggleIcon } from 'assets/SVGIcons'

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  item: {
    margin: 0,
    width: 40,
    padding: 5,
    height: 40,
    display: 'flex',
    borderRadius: 22,
    cursor: 'pointer',
    textAlign: 'left',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.white,
    boxShadow: '0px 4px 10px rgba(0,0,0,0.4)',
    '&:hover': {
      backgroundColor: theme.palette.background.light,
    },
  },
  zoom: {
    boxShadow: 'none',
  },
  zoomIn: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  zoomOut: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  zoomContainer: {
    width: 40,
    borderRadius: 22,
    margin: `${theme.spacing(2)}px 0`,
    backgroundColor: theme.palette.white,
    boxShadow: '0px 4px 10px rgba(0,0,0,0.4)',
  },
  icon: {
    color: theme.palette.tertiary.main,
    height: 22,
    width: 22,
  },
  largeIcon: {
    width: 32,
    height: 32,
  },
  activeItem: {
    backgroundColor: theme.palette.tertiary.main,
    '& path': {
      fill: theme.palette.white,
    },
    '&:hover': {
      backgroundColor: theme.palette.tertiary.dark,
    },
  },
})

class MapControls extends PureComponent {
  onZoomIn = () => {
    const { handleZoom } = this.props
    handleZoom(1)
  };

  onZoomOut = () => {
    const { handleZoom } = this.props
    handleZoom(-1)
  };

  onHeatmapToggle = () => {
    const { handleHeatmapToggle, heatmapActive } = this.props
    handleHeatmapToggle(!heatmapActive)
  };

  render() {
    const {
      classes, className, handleReset, heatmapActive
    } = this.props

    return (
      <div className={classNames(classes.root, className)}>
        <div onClick={handleReset} className={classes.item}>
          <LocationIcon className={classes.icon} />
        </div>
        <div className={classes.zoomContainer}>
          <div
            onClick={this.onZoomIn}
            className={classNames(classes.item, classes.zoom, classes.zoomIn)}>
            <Add className={classes.icon} />
          </div>
          <div
            onClick={this.onZoomOut}
            className={classNames(classes.item, classes.zoom, classes.zoomOut)}>
            <Remove className={classes.icon} />
          </div>
        </div>
        <div
          onClick={this.onHeatmapToggle}
          className={classNames(
            classes.item,
            heatmapActive && classes.activeItem
          )}>
          <HeatmapToggleIcon className={classes.largeIcon} />
        </div>
      </div>
    )
  }
}

MapControls.propTypes = {
  classes: PropTypes.object,
  handleZoom: PropTypes.func,
  handleReset: PropTypes.func,
  className: PropTypes.string,
  currentZoom: PropTypes.number,
  heatmapActive: PropTypes.bool,
  handleHeatmapToggle: PropTypes.func,
}

export default withStyles(styles)(MapControls)



// WEBPACK FOOTER //
// ./src/components/molecules/MapControls.js